import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
//import { Router } from "@angular/router";
import * as firebase from 'firebase';
import { user } from '../../shared/user';

@Injectable()
export class AuthProvider {
  authState: any = null;
  constructor(private afAuth: AngularFireAuth,
    private db: AngularFireDatabase
    //  ,private router:Router
  ) {

    this.afAuth.authState.subscribe((auth) => {
      console.log(auth);
      this.authState = auth
    });

   
  }

  // Returns true if user is logged in
  get authenticated(): boolean {
    return this.authState !== null;
  }

  // Returns current user data
  get currentUser(): any {
    return this.authenticated ? this.authState : null;
  }

  // Returns
  get currentUserObservable(): any {
    return this.afAuth.authState
  }

  // Returns current user UID
  get currentUserId(): string {
    return this.authenticated ? this.authState.uid : '';
  }

  // Anonymous User
  get currentUserAnonymous(): boolean {
    return this.authenticated ? this.authState.isAnonymous : false
  }

  // Returns current user display name or Guest
  get currentUserDisplayName(): string {
    if (!this.authState) { return 'Guest' }
    else if (this.currentUserAnonymous) { return 'Anonymous' }
    else { return this.authState['displayName'] || 'User without a Name' }
  }

  //// Social Auth ////
  googleLogin() {
    const provider = new firebase.auth.GoogleAuthProvider();
    return this.socialSignIn(provider);
  }

  facebookLogin() {
    const provider = new firebase.auth.FacebookAuthProvider();
    return this.socialSignIn(provider);
  }

  private socialSignIn(provider) {
    return this.afAuth.auth.signInWithPopup(provider)
      .then((credential) => {
        this.authState = credential.user;
        this.updateUserData(1)
      })
      .catch(error => 
      console.log(error)
      );
  }

  //// Email/Password Auth ////
  emailSignUp(email: string, password: string) {
    return this.afAuth.auth.createUserWithEmailAndPassword(email, "12345")
      .then((user) => {
        this.authState = user;
        this.updateUserData(1);
        var auth = firebase.auth();

        return auth.sendPasswordResetEmail(email)
          .then(() => console.log("email sent"))
          .catch((error) => console.log(error))
      })
      .catch(error => console.log(error));
  }

  emailSignUpByUser(user: user) {
    return this.afAuth.auth.createUserWithEmailAndPassword(user.email, "pavan@2106");
    //   .then((response) => {
    //   this.authState = response;
    //  this.updateUserDataByUser(user)
    //  var auth = firebase.auth();

    //return auth.sendPasswordResetEmail(user.email)
    //.then(() => console.log("email sent"))
    //.catch((error) => console.log(error))
    //
    // })
    // .catch(error => console.log(error));
  }

  emailLogin(email: string, password: string) {
    if (this.authState != null && this.authState != undefined)
      return this.authState;
    return this.afAuth.auth.signInWithEmailAndPassword(email, password)
      .then((user) => {
        this.authState = user
        return this.authState;
      })
      .catch(error => {
        this.authState = undefined;
        return error;
      });
  }

  // Sends email allowing user to reset password
  resetPassword(email: string) {
    var auth = firebase.auth();

    return auth.sendPasswordResetEmail(email)
      .then(() => console.log("email sent"))
      .catch((error) => console.log(error))
  }


  //// Sign Out ////
  signOut(): void {
    this.afAuth.auth.signOut();
    // this.router.navigate(['/'])
  }


  //// Helpers ////
  private updateUserData(roleId): void {
    // Writes user name and email to realtime db
    // useful if your app displays information about users or for admin features
    let path = `users/${this.currentUserId}`; // Endpoint on firebase
    let data = {
      email: this.authState.email,
      name: this.authState.displayName,
      role: roleId
    }

    this.db.object(path).update(data)
      .catch(error => console.log(error));

  }


  public updateUserDataByUser(uid, user): void {
    // Writes user name and email to realtime db
    // useful if your app displays information about users or for admin features
    let path = `users/${uid}`; // Endpoint on firebase
    let data = user;

    this.db.object(path).update(data)
      .catch(error => console.log(error));

  }

  public updateResturent(uid, client): string {
    // Writes user name and email to realtime db
    // useful if your app displays information about users or for admin features
    let isNew = !uid || uid == null || uid == undefined;
    let path = !isNew ? `restaurants/${uid}` : `restaurants`; // Endpoint on firebase
    let data = user;
    if (!isNew)
      this.db.object(path).update(data);
    else {
      let restaurants = firebase.database().ref().child('restaurants');
      let newPostRef = restaurants.push(client);
      return newPostRef.key;
    }

    return uid;
  }

  public getUserData(uid) {
    // Writes user name and email to realtime db
    // useful if your app displays information about users or for admin features
    let path = `users/${uid}`; // Endpoint on firebase
    return this.db.object(path);
  }

  /*public setWaiterAvailability(restPath, waiterId, value){
    this.db.object(restPath+'/'+waiterId+'/isAvailable').set(value);
  }*/

  public updateWaiterDetails(restPath, waiterId, value){
    this.db.object(restPath+'/'+waiterId).set(value);
  }

 /* public pushWaiterDetails(restPath, value){
    this.db.list(restPath).push(value).then(res => { console.log(JSON.stringify(res)); });;
  }*/
}



// WEBPACK FOOTER //
// ./src/providers/authservice/auth.ts